// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_pagination__7uuis button, .style_pagination__7uuis div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__\\+-EC7 {
  display: flex;
  align-items: center;
}

.style_interface_noResults__D4wFj {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_interface__ZO4GA {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.style_link__r2lIP {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__r2lIP:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__PGlwk {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__2Pa0V {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__JLvSn, .style_interface_heading__ypkVH, .style_interface_footer__z\\+R2- {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__QqW-e {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__VntgK {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__VntgK {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__gFfZM {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__gFfZM {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__eVgVn {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__eVgVn {
    line-height: 1.5rem;
  }
}

.style_breadcumb__IH7l0 {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__IH7l0 a,
.style_breadcumb__IH7l0 span {
  padding: 3px 5px;
}
.style_breadcumb__IH7l0 a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__IH7l0 a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__IH7l0 .style_divider__Qb2rn {
  color: var(--color-gray-400);
}

.style_badge__K4CUh {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__K4CUh.style_xs__3jFlB {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__K4CUh.style_sm__sNdpr {
  padding: 4px 7px;
}
.style_badge__K4CUh.style_primary__bzdoj {
  background: var(--color-primary-500);
}
.style_badge__K4CUh.style_primary__bzdoj, .style_badge__K4CUh.style_pm__Mzbbu {
  background: var(--color-primary-500);
}
.style_badge__K4CUh.style_sd__28768 {
  background-color: var(--color-secundary-500);
}
.style_badge__K4CUh.style_Likely__ANs1V {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__K4CUh.style_Unvalidated__tJZeV {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__K4CUh.style_Verified__RPLsK, .style_badge__K4CUh.style_green__Tounn {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__K4CUh.style_off__1BYuB {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__m7ite {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__m7ite.style_xs__3jFlB {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__m7ite.style_sm__sNdpr {
  padding: 4px 7px;
}
.style_badgeTable__m7ite.style_primary__bzdoj, .style_badgeTable__m7ite.style_pm__Mzbbu {
  background: var(--color-primary-500);
}
.style_badgeTable__m7ite.style_sd__28768 {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__m7ite.style_Likely__ANs1V {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__m7ite.style_Verified__RPLsK, .style_badgeTable__m7ite.style_green__Tounn {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__m7ite.style_off__1BYuB {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__iTtoL {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__iTtoL.style_style-1__-laUE td,
.style_table__iTtoL.style_style-1__-laUE th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__iTtoL.style_style-1__-laUE th,
.style_table__iTtoL.style_style-1__-laUE td.style_label__UVJ89 {
  color: var(--color-white-500);
}
.style_table__iTtoL.style_style-1__-laUE th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__iTtoL.style_style-1__-laUE tr.style_noBorder__rosze td {
  border-bottom: none;
}
.style_table__iTtoL.style_style-1__-laUE tr td {
  color: var(--color-white-500);
}

.style_pagination__7uuis {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__7uuis button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__7uuis button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__7uuis button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__7uuis button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__7uuis button.style_disabled__hKjUP, .style_pagination__7uuis button.style_active__X46IR, .style_pagination__7uuis button.style_info__FQERC {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__7uuis button.style_disabled__hKjUP {
  color: var(--color-gray-700);
}
.style_pagination__7uuis div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__7uuis div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__7uuis div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__7uuis div:hover, .style_pagination__7uuis div.style_active__X46IR {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__7uuis div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__7uuis div.style_disabled__hKjUP, .style_pagination__7uuis div.style_active__X46IR, .style_pagination__7uuis div.style_info__FQERC {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__7uuis div.style_disabled__hKjUP {
  color: var(--color-gray-700);
}
.style_pagination__7uuis div:last-child, .style_pagination__7uuis div:first-child {
  padding: 0 10px;
}
.style_pagination__7uuis div:last-child {
  border-right: none;
}
.style_pagination__7uuis button:last-child, .style_pagination__7uuis button:first-child {
  padding: 0 10px;
}
.style_pagination__7uuis button:last-child {
  border-right: none;
}

.style_interface__ZO4GA {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__ypkVH {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__ypkVH {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__ypkVH > div {
    width: 100%;
  }
}
.style_interface_heading_row__\\+-EC7 {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__\\+-EC7 {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__z\\+R2- {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__z\\+R2- {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__z\\+R2- > div {
    width: 100%;
  }
}
.style_interface_foot__oHGfh {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__oHGfh {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__D4wFj {
  gap: 15px;
  padding: 70px 0;
}

@keyframes style_glitch-anim-1__dh-nH {
  0% {
    clip-path: inset(40% 0 61% 0);
    transform: translate(-5px, 0) scale(1.02);
  }
  20% {
    clip-path: inset(92% 0 1% 0);
    transform: translate(5px, -3px) scale(1.01);
  }
  40% {
    clip-path: inset(43% 0 1% 0);
    transform: translate(-7px, 2px) scale(1.03);
  }
  60% {
    clip-path: inset(25% 0 58% 0);
    transform: translate(8px, -1px) scale(1.02);
  }
  80% {
    clip-path: inset(54% 0 7% 0);
    transform: translate(-10px, 3px) scale(1.01);
  }
  100% {
    clip-path: inset(58% 0 43% 0);
    transform: translate(0, 0) scale(1);
  }
}
@keyframes style_glitch-anim-2__PuM0I {
  0% {
    clip-path: inset(25% 0 58% 0);
    transform: translate(-5px, 0) rotate(0.5deg);
  }
  20% {
    clip-path: inset(1% 0 94% 0);
    transform: translate(5px, -2px) rotate(-0.5deg);
  }
  40% {
    clip-path: inset(58% 0 43% 0);
    transform: translate(-7px, 1px) rotate(0.3deg);
  }
  60% {
    clip-path: inset(3% 0 83% 0);
    transform: translate(8px, -3px) rotate(-0.7deg);
  }
  80% {
    clip-path: inset(76% 0 21% 0);
    transform: translate(-10px, 2px) rotate(0.4deg);
  }
  100% {
    clip-path: inset(19% 0 6% 0);
    transform: translate(0, 0) rotate(0deg);
  }
}
@keyframes style_text-glitch__wKIaX {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-2px, 1px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(1px, 1px);
  }
  80% {
    transform: translate(1px, -1px);
  }
  100% {
    transform: translate(0);
  }
}
@keyframes style_flicker__JRMWg {
  0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100% {
    opacity: 0.99;
  }
  20%, 21.999%, 63%, 63.999%, 65%, 69.999% {
    opacity: 0.4;
  }
}
@keyframes style_distort__FaXdh {
  0% {
    transform: skew(0deg);
  }
  25% {
    transform: skew(0.5deg, 0.5deg);
  }
  50% {
    transform: skew(-0.5deg, -0.1deg);
  }
  75% {
    transform: skew(0.3deg, -0.5deg);
  }
  100% {
    transform: skew(-0.2deg, 0.2deg);
  }
}
@keyframes style_glitch-block__AwTIC {
  0% {
    left: -100%;
    opacity: 0;
  }
  10% {
    left: 0%;
    opacity: 0.8;
  }
  15% {
    left: 100%;
    opacity: 0;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}
@keyframes style_noise-anim__snOkt {
  0% {
    clip: rect(18px, 9999px, 46px, 0);
  }
  5% {
    clip: rect(92px, 9999px, 61px, 0);
  }
  10% {
    clip: rect(100px, 9999px, 98px, 0);
  }
  15% {
    clip: rect(137px, 9999px, 147px, 0);
  }
  20% {
    clip: rect(30px, 9999px, 55px, 0);
  }
  25% {
    clip: rect(56px, 9999px, 38px, 0);
  }
  30% {
    clip: rect(86px, 9999px, 37px, 0);
  }
  35% {
    clip: rect(32px, 9999px, 12px, 0);
  }
  40% {
    clip: rect(59px, 9999px, 55px, 0);
  }
  45% {
    clip: rect(68px, 9999px, 25px, 0);
  }
  50% {
    clip: rect(82px, 9999px, 33px, 0);
  }
  55% {
    clip: rect(49px, 9999px, 44px, 0);
  }
  60% {
    clip: rect(72px, 9999px, 67px, 0);
  }
  65% {
    clip: rect(99px, 9999px, 91px, 0);
  }
  70% {
    clip: rect(44px, 9999px, 48px, 0);
  }
  75% {
    clip: rect(33px, 9999px, 15px, 0);
  }
  80% {
    clip: rect(93px, 9999px, 64px, 0);
  }
  85% {
    clip: rect(20px, 9999px, 71px, 0);
  }
  90% {
    clip: rect(23px, 9999px, 22px, 0);
  }
  95% {
    clip: rect(79px, 9999px, 73px, 0);
  }
  100% {
    clip: rect(10px, 9999px, 18px, 0);
  }
}
.style_container__p893W {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  color: var(--text-color-W);
  background: linear-gradient(135deg, #1a1d2a 0%, #0d0f18 100%);
  position: relative;
  overflow: hidden;
  animation: style_flicker__JRMWg 8s infinite;
}
.style_container__p893W::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 3%), radial-gradient(circle at 75% 30%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 4%), radial-gradient(circle at 46% 66%, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 2.5%);
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 1;
}
.style_container__p893W::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, transparent 94%, rgba(255, 255, 255, 0.15) 95%, transparent 96%), linear-gradient(135deg, transparent 44%, rgba(255, 255, 255, 0.15) 45%, transparent 46%), linear-gradient(45deg, transparent 44%, rgba(255, 255, 255, 0.15) 45%, transparent 46%), linear-gradient(to right, transparent 10%, rgba(0, 0, 0, 0.2) 11%, transparent 12%), linear-gradient(to right, transparent 20%, rgba(0, 0, 0, 0.2) 21%, transparent 22%), linear-gradient(to bottom, transparent 40%, rgba(0, 0, 0, 0.2) 41%, transparent 42%);
  background-size: 300% 300%, 200% 200%, 300% 300%, 100% 100%, 100% 100%, 100% 100%;
  pointer-events: none;
  z-index: 1;
}
.style_container__p893W .style_overlay__1QE8\\+ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 50%, transparent 50%), linear-gradient(90deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.04) 2px, transparent 3px, transparent 8px), linear-gradient(transparent 0%, rgba(0, 0, 0, 0.1) 10%, rgba(0, 0, 0, 0.1) 90%, transparent 100%);
  background-size: 100% 2px, 10px 100%, 100% 100%;
  pointer-events: none;
  z-index: 2;
  opacity: 0.7;
  animation: style_distort__FaXdh 1s infinite alternate;
}
.style_container__p893W .style_vignette__-1jNA {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0) 65%, rgba(0, 0, 0, 0.7) 100%);
  pointer-events: none;
  z-index: 3;
}
.style_container__p893W .style_glitch-block__AwTIC {
  position: absolute;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.2);
  z-index: 4;
  opacity: 0;
}
.style_container__p893W .style_glitch-block__AwTIC:nth-child(1) {
  top: 30%;
  animation: style_glitch-block__AwTIC 2.5s infinite 0.5s;
}
.style_container__p893W .style_glitch-block__AwTIC:nth-child(2) {
  top: 70%;
  animation: style_glitch-block__AwTIC 2.5s infinite 1s;
}
.style_container__p893W h1 {
  font-size: 126px;
  margin: 0;
  font-weight: 800;
  position: relative;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: -2px;
  z-index: 10;
  text-shadow: 2px 2px 0px #6366f1;
}
.style_container__p893W h1::before, .style_container__p893W h1::after {
  content: "404";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.style_container__p893W h1::before {
  color: #d946ef;
  animation: style_glitch-anim-1__dh-nH 1.5s infinite linear alternate-reverse;
}
.style_container__p893W h1::after {
  color: #6366f1;
  animation: style_glitch-anim-2__PuM0I 2s infinite linear alternate-reverse;
}
.style_container__p893W p {
  font-size: 24px;
  margin: 15px 0 0;
  font-weight: 500;
  position: relative;
  z-index: 10;
  letter-spacing: 0.5px;
  text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
  color: #d946ef;
  animation: style_text-glitch__wKIaX 1.5s infinite;
}
.style_container__p893W p::after {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: -2px;
  color: #6366f1;
  background: rgba(13, 15, 24, 0.7);
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: style_noise-anim__snOkt 3s infinite linear alternate-reverse;
}
.style_container__p893W button {
  width: max-content;
  padding: 12px 28px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  border: none;
  color: white;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);
  position: relative;
  z-index: 10;
  margin-top: 20px;
}
.style_container__p893W button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(99, 102, 241, 0.4);
  background: linear-gradient(90deg, #8b5cf6, #d946ef);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/pages/Error/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_mixin.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACVF;;AD6BA;EACE,aAAA;EACA,sBAAA;AC1BF;;ACbA;EACI,qBAAA;ADgBJ;;ACdA;EACI,eAAA;EACA,cAAA;ADiBJ;AChBI;EACE,0BAAA;ADkBN;;ACdA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADiBJ;;ACdI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ADiBR;ACfI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ADiBR;ACfI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ADiBR;ACfI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADiBR;AEzDE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EDmBV;AACF;ACjBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADmBR;AEnEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;EDqBV;AACF;ACnBI;EACI,mBAAA;ADqBR;AE5EE;EDsDE;IAGQ,mBAAA;EDuBV;AACF;;AG/EA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AHkFF;AGjFE;;EAEE,gBAAA;AHmFJ;AGjFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AHmFJ;AGlFI;EACE,+BAAA;EACA,uCAAA;AHoFN;AGjFE;EACE,4BAAA;AHmFJ;;AIvGA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ0GF;AIvGE;EACE,gBAAA;EACA,eAAA;AJyGJ;AIvGE;EACE,gBAAA;AJyGJ;AIrGE;EACE,oCAAA;AJuGJ;AIrGE;EAEE,oCAAA;AJsGJ;AIpGE;EACE,4CAAA;AJsGJ;AIpGE;EACE,uCAAA;EACA,mCAAA;AJsGJ;AIpGE;EACE,oCAAA;EACA,gCAAA;AJsGJ;AIpGE;EAEE,4CAAA;EACA,kCAAA;AJqGJ;AInGE;EACE,6BAAA;EACA,uCAAA;AJqGJ;;AIlGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJqGF;AIlGE;EACE,gBAAA;EACA,eAAA;AJoGJ;AIlGE;EACE,gBAAA;AJoGJ;AIhGE;EAEE,oCAAA;AJiGJ;AI/FE;EACE,4CAAA;AJiGJ;AI/FE;EACE,mBAAA;EACA,cAAA;AJiGJ;AI/FE;EAEE,4CAAA;EACA,kCAAA;AJgGJ;AI9FE;EACE,6BAAA;EACA,uCAAA;AJgGJ;;AKxLA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;AL2LF;AKzLI;;EAEE,kBAAA;EACA,mBAAA;AL2LN;AKzLI;;EAEE,6BAAA;AL2LN;AKzLI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;AL2LN;AKxLM;EACE,mBAAA;AL0LR;AKxLM;EACE,6BAAA;AL0LR;;AM9MA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;ANgNJ;AM9MI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;AN+MR;AM9MQ;EACI,2BAAA;EACA,8BAAA;ANgNZ;AM9MQ;EACI,4BAAA;EACA,+BAAA;ANgNZ;AE/OE;EIgBE;IAkBQ,eAAA;IACA,eAAA;ENiNV;AACF;AMhNQ;EACI,eAAA;EACA,oBAAA;ANkNZ;AMhNQ;EACI,4BAAA;ANkNZ;AM/MI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANgNR;AM/MQ;EACI,2BAAA;EACA,8BAAA;ANiNZ;AM/MQ;EACI,4BAAA;EACA,+BAAA;ANiNZ;AM/MQ;ECrCJ,eAAA;EACA,qFAAA;APuPJ;AEjRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;ENmNV;AACF;AMlNQ;EACI,eAAA;EACA,oBAAA;ANoNZ;AMlNQ;EACI,4BAAA;ANoNZ;AMjNI;EACI,eAAA;ANmNR;AMjNI;EACI,kBAAA;ANmNR;AMjNI;EACI,eAAA;ANmNR;AMjNI;EACI,kBAAA;ANmNR;;AQrSA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;ARwSF;AQtSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARuSJ;AE/TE;EMeA;IAWI,kBAAA;IACA,uBAAA;ERySJ;EQxSI;IACE,WAAA;ER0SN;AACF;AQxSI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;ARySN;AE7UE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ER2SN;AACF;AQxSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARySJ;AE7VE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ER2SJ;EQ1SI;IACE,WAAA;ER4SN;AACF;AQzSE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AR2SJ;AE3WE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ER6SJ;AACF;AQ3SE;EAEE,SAAA;EACA,eAAA;AR4SJ;;AApXA;EACE;IAAK,6BAAA;IAA+B,yCAAA;EAyXpC;EAxXA;IAAM,4BAAA;IAA8B,2CAAA;EA4XpC;EA3XA;IAAM,4BAAA;IAA8B,2CAAA;EA+XpC;EA9XA;IAAM,6BAAA;IAA+B,2CAAA;EAkYrC;EAjYA;IAAM,4BAAA;IAA8B,4CAAA;EAqYpC;EApYA;IAAO,6BAAA;IAA+B,mCAAA;EAwYtC;AACF;AAtYA;EACE;IAAK,6BAAA;IAA+B,4CAAA;EA0YpC;EAzYA;IAAM,4BAAA;IAA8B,+CAAA;EA6YpC;EA5YA;IAAM,6BAAA;IAA+B,8CAAA;EAgZrC;EA/YA;IAAM,4BAAA;IAA8B,+CAAA;EAmZpC;EAlZA;IAAM,6BAAA;IAA+B,+CAAA;EAsZrC;EArZA;IAAO,4BAAA;IAA8B,uCAAA;EAyZrC;AACF;AAvZA;EACE;IAAK,uBAAA;EA0ZL;EAzZA;IAAM,+BAAA;EA4ZN;EA3ZA;IAAM,gCAAA;EA8ZN;EA7ZA;IAAM,8BAAA;EAgaN;EA/ZA;IAAM,+BAAA;EAkaN;EAjaA;IAAO,uBAAA;EAoaP;AACF;AAlaA;EACE;IAAqD,aAAA;EAqarD;EApaA;IAA2C,YAAA;EAua3C;AACF;AAraA;EACE;IAAK,qBAAA;EAwaL;EAvaA;IAAM,+BAAA;EA0aN;EAzaA;IAAM,iCAAA;EA4aN;EA3aA;IAAM,gCAAA;EA8aN;EA7aA;IAAO,gCAAA;EAgbP;AACF;AA9aA;EACE;IAAK,WAAA;IAAa,UAAA;EAkblB;EAjbA;IAAM,QAAA;IAAU,YAAA;EAqbhB;EApbA;IAAM,UAAA;IAAY,UAAA;EAwblB;EAvbA;IAAO,UAAA;IAAY,UAAA;EA2bnB;AACF;AAzbA;EACE;IAAK,iCAAA;EA4bL;EA3bA;IAAK,iCAAA;EA8bL;EA7bA;IAAM,kCAAA;EAgcN;EA/bA;IAAM,mCAAA;EAkcN;EAjcA;IAAM,iCAAA;EAocN;EAncA;IAAM,iCAAA;EAscN;EArcA;IAAM,iCAAA;EAwcN;EAvcA;IAAM,iCAAA;EA0cN;EAzcA;IAAM,iCAAA;EA4cN;EA3cA;IAAM,iCAAA;EA8cN;EA7cA;IAAM,iCAAA;EAgdN;EA/cA;IAAM,iCAAA;EAkdN;EAjdA;IAAM,iCAAA;EAodN;EAndA;IAAM,iCAAA;EAsdN;EArdA;IAAM,iCAAA;EAwdN;EAvdA;IAAM,iCAAA;EA0dN;EAzdA;IAAM,iCAAA;EA4dN;EA3dA;IAAM,iCAAA;EA8dN;EA7dA;IAAM,iCAAA;EAgeN;EA/dA;IAAM,iCAAA;EAkeN;EAjeA;IAAO,iCAAA;EAoeP;AACF;AAleA;ESxEC,aAAA;EACA,mBTwEe;ESvEf,uBTuEuB;EStEvB,STsE+B;ESrE/B,sBTqEqC;EACpC,WAAA;EACA,aAAA;EACA,0BU9Da;EV+Db,6DAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;AAweF;AAteE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kSACE;EAGF,8CAAA;EACA,oBAAA;EACA,UAAA;AAqeJ;AAleE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,siBACE;EAMF,iFAAA;EACA,oBAAA;EACA,UAAA;AA8dJ;AA3dE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uSACE;EAGF,+CAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;EACA,qDAAA;AA0dJ;AAvdE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6FAAA;EACA,oBAAA;EACA,UAAA;AAydJ;AAtdE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EACA,UAAA;AAwdJ;AAvdI;EAAiB,QAAA;EAAU,uDAAA;AA2d/B;AA1dI;EAAiB,QAAA;EAAU,qDAAA;AA8d/B;AA3dE;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;EACA,WAAA;EACA,gCAAA;AA6dJ;AA3dI;EAEE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA4dN;AAzdI;EACE,cAAA;EACA,4EAAA;AA2dN;AAxdI;EACE,cAAA;EACA,0EAAA;AA0dN;AAtdE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,6CAAA;EACA,cAAA;EACA,iDAAA;AAwdJ;AAtdI;EACE,wBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,uEAAA;AAwdN;AApdE;EACE,kBAAA;EACA,kBAAA;EACA,oDAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,8CAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAsdJ;AApdI;EACE,2BAAA;EACA,8CAAA;EACA,oDAAA;AAsdN","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"../../assets/scss/\" as *;\n\n@keyframes glitch-anim-1 {\n  0% { clip-path: inset(40% 0 61% 0); transform: translate(-5px, 0) scale(1.02); }\n  20% { clip-path: inset(92% 0 1% 0); transform: translate(5px, -3px) scale(1.01); }\n  40% { clip-path: inset(43% 0 1% 0); transform: translate(-7px, 2px) scale(1.03); }\n  60% { clip-path: inset(25% 0 58% 0); transform: translate(8px, -1px) scale(1.02); }\n  80% { clip-path: inset(54% 0 7% 0); transform: translate(-10px, 3px) scale(1.01); }\n  100% { clip-path: inset(58% 0 43% 0); transform: translate(0, 0) scale(1); }\n}\n\n@keyframes glitch-anim-2 {\n  0% { clip-path: inset(25% 0 58% 0); transform: translate(-5px, 0) rotate(0.5deg); }\n  20% { clip-path: inset(1% 0 94% 0); transform: translate(5px, -2px) rotate(-0.5deg); }\n  40% { clip-path: inset(58% 0 43% 0); transform: translate(-7px, 1px) rotate(0.3deg); }\n  60% { clip-path: inset(3% 0 83% 0); transform: translate(8px, -3px) rotate(-0.7deg); }\n  80% { clip-path: inset(76% 0 21% 0); transform: translate(-10px, 2px) rotate(0.4deg); }\n  100% { clip-path: inset(19% 0 6% 0); transform: translate(0, 0) rotate(0deg); }\n}\n\n@keyframes text-glitch {\n  0% { transform: translate(0); }\n  20% { transform: translate(-2px, 1px); }\n  40% { transform: translate(-2px, -2px); }\n  60% { transform: translate(1px, 1px); }\n  80% { transform: translate(1px, -1px); }\n  100% { transform: translate(0); }\n}\n\n@keyframes flicker {\n  0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100% { opacity: 0.99; }\n  20%, 21.999%, 63%, 63.999%, 65%, 69.999% { opacity: 0.4; }\n}\n\n@keyframes distort {\n  0% { transform: skew(0deg); }\n  25% { transform: skew(0.5deg, 0.5deg); }\n  50% { transform: skew(-0.5deg, -0.1deg); }\n  75% { transform: skew(0.3deg, -0.5deg); }\n  100% { transform: skew(-0.2deg, 0.2deg); }\n}\n\n@keyframes glitch-block {\n  0% { left: -100%; opacity: 0; }\n  10% { left: 0%; opacity: 0.8; }\n  15% { left: 100%; opacity: 0; }\n  100% { left: 100%; opacity: 0; }\n}\n\n@keyframes noise-anim {\n  0% { clip: rect(18px, 9999px, 46px, 0); }\n  5% { clip: rect(92px, 9999px, 61px, 0); }\n  10% { clip: rect(100px, 9999px, 98px, 0); }\n  15% { clip: rect(137px, 9999px, 147px, 0); }\n  20% { clip: rect(30px, 9999px, 55px, 0); }\n  25% { clip: rect(56px, 9999px, 38px, 0); }\n  30% { clip: rect(86px, 9999px, 37px, 0); }\n  35% { clip: rect(32px, 9999px, 12px, 0); }\n  40% { clip: rect(59px, 9999px, 55px, 0); }\n  45% { clip: rect(68px, 9999px, 25px, 0); }\n  50% { clip: rect(82px, 9999px, 33px, 0); }\n  55% { clip: rect(49px, 9999px, 44px, 0); }\n  60% { clip: rect(72px, 9999px, 67px, 0); }\n  65% { clip: rect(99px, 9999px, 91px, 0); }\n  70% { clip: rect(44px, 9999px, 48px, 0); }\n  75% { clip: rect(33px, 9999px, 15px, 0); }\n  80% { clip: rect(93px, 9999px, 64px, 0); }\n  85% { clip: rect(20px, 9999px, 71px, 0); }\n  90% { clip: rect(23px, 9999px, 22px, 0); }\n  95% { clip: rect(79px, 9999px, 73px, 0); }\n  100% { clip: rect(10px, 9999px, 18px, 0); }\n}\n\n.container {\n  @include flex(center, center, 30px, column);\n  width: 100%;\n  height: 100vh;\n  color: $text-color-W;\n  background: linear-gradient(135deg, #1a1d2a 0%, #0d0f18 100%);\n  position: relative;\n  overflow: hidden;\n  animation: flicker 8s infinite;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: \n      radial-gradient(circle at 25% 25%, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 3%),\n      radial-gradient(circle at 75% 30%, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 4%),\n      radial-gradient(circle at 46% 66%, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 2.5%);\n    box-shadow: inset 0 0 100px rgba(0,0,0,0.5);\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: \n      linear-gradient(90deg, transparent 0%, transparent 94%, rgba(255,255,255,0.15) 95%, transparent 96%),\n      linear-gradient(135deg, transparent 44%, rgba(255,255,255,0.15) 45%, transparent 46%),\n      linear-gradient(45deg, transparent 44%, rgba(255,255,255,0.15) 45%, transparent 46%),\n      linear-gradient(to right, transparent 10%, rgba(0,0,0,0.2) 11%, transparent 12%),\n      linear-gradient(to right, transparent 20%, rgba(0,0,0,0.2) 21%, transparent 22%),\n      linear-gradient(to bottom, transparent 40%, rgba(0,0,0,0.2) 41%, transparent 42%);\n    background-size: 300% 300%, 200% 200%, 300% 300%, 100% 100%, 100% 100%, 100% 100%;\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: \n      linear-gradient(0deg, rgba(0,0,0,0.2) 50%, transparent 50%),\n      linear-gradient(90deg, rgba(255,255,255,0.04), rgba(255,255,255,0.04) 2px, transparent 3px, transparent 8px),\n      linear-gradient(transparent 0%, rgba(0,0,0,0.1) 10%, rgba(0,0,0,0.1) 90%, transparent 100%);\n    background-size: 100% 2px, 10px 100%, 100% 100%;\n    pointer-events: none;\n    z-index: 2;\n    opacity: 0.7;\n    animation: distort 1s infinite alternate;\n  }\n\n  .vignette {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(ellipse at center, rgba(0,0,0,0) 65%, rgba(0,0,0,0.7) 100%);\n    pointer-events: none;\n    z-index: 3;\n  }\n\n  .glitch-block {\n    position: absolute;\n    width: 100%;\n    height: 3px;\n    background: rgba(255,255,255,0.2);\n    z-index: 4;\n    opacity: 0;\n    &:nth-child(1) { top: 30%; animation: glitch-block 2.5s infinite 0.5s; }\n    &:nth-child(2) { top: 70%; animation: glitch-block 2.5s infinite 1s; }\n  }\n\n  h1 {\n    font-size: 126px;\n    margin: 0;\n    font-weight: 800;\n    position: relative;\n    color: rgba(255, 255, 255, 0.9);\n    letter-spacing: -2px;\n    z-index: 10;\n    text-shadow: 2px 2px 0px #6366f1;\n\n    &::before,\n    &::after {\n      content: \"404\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: -1;\n    }\n\n    &::before {\n      color: #d946ef;\n      animation: glitch-anim-1 1.5s infinite linear alternate-reverse;\n    }\n\n    &::after {\n      color: #6366f1;\n      animation: glitch-anim-2 2s infinite linear alternate-reverse;\n    }\n  }\n\n  p {\n    font-size: 24px;\n    margin: 15px 0 0;\n    font-weight: 500;\n    position: relative;\n    z-index: 10;\n    letter-spacing: 0.5px;\n    text-shadow: 0 0 2px rgba(255,255,255,0.5);\n    color: #d946ef;\n    animation: text-glitch 1.5s infinite;\n\n    &::after {\n      content: attr(data-text);\n      position: absolute;\n      top: 0;\n      left: -2px;\n      color: #6366f1;\n      background: rgba(13, 15, 24, 0.7);\n      overflow: hidden;\n      clip: rect(0, 900px, 0, 0);\n      animation: noise-anim 3s infinite linear alternate-reverse;\n    }\n  }\n\n  button {\n    width: max-content;\n    padding: 12px 28px;\n    background: linear-gradient(90deg, #6366f1, #8b5cf6);\n    border: none;\n    color: white;\n    font-weight: 500;\n    font-size: 16px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);\n    position: relative;\n    z-index: 10;\n    margin-top: 20px;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 25px rgba(99, 102, 241, 0.4);\n      background: linear-gradient(90deg, #8b5cf6, #d946ef);\n    }\n  }\n}","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","@mixin flex($align-item, $justify-content, $gap: 0, $flex-direction: row) {\n\tdisplay: flex;\n\talign-items: $align-item;\n\tjustify-content: $justify-content;\n\tgap: $gap;\n\tflex-direction: $flex-direction;\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `style_pagination__7uuis`,
	"interface_heading_row": `style_interface_heading_row__+-EC7`,
	"interface_noResults": `style_interface_noResults__D4wFj`,
	"interface": `style_interface__ZO4GA`,
	"link": `style_link__r2lIP`,
	"text-gradient-intel": `style_text-gradient-intel__PGlwk`,
	"text-xs": `style_text-xs__2Pa0V`,
	"text-sm": `style_text-sm__JLvSn`,
	"interface_heading": `style_interface_heading__ypkVH`,
	"interface_footer": `style_interface_footer__z+R2-`,
	"text-base": `style_text-base__QqW-e`,
	"text-lg": `style_text-lg__VntgK`,
	"text-xl": `style_text-xl__gFfZM`,
	"text-leading": `style_text-leading__eVgVn`,
	"breadcumb": `style_breadcumb__IH7l0`,
	"divider": `style_divider__Qb2rn`,
	"badge": `style_badge__K4CUh`,
	"xs": `style_xs__3jFlB`,
	"sm": `style_sm__sNdpr`,
	"primary": `style_primary__bzdoj`,
	"pm": `style_pm__Mzbbu`,
	"sd": `style_sd__28768`,
	"Likely": `style_Likely__ANs1V`,
	"Unvalidated": `style_Unvalidated__tJZeV`,
	"Verified": `style_Verified__RPLsK`,
	"green": `style_green__Tounn`,
	"off": `style_off__1BYuB`,
	"badgeTable": `style_badgeTable__m7ite`,
	"table": `style_table__iTtoL`,
	"style-1": `style_style-1__-laUE`,
	"label": `style_label__UVJ89`,
	"noBorder": `style_noBorder__rosze`,
	"disabled": `style_disabled__hKjUP`,
	"active": `style_active__X46IR`,
	"info": `style_info__FQERC`,
	"interface_foot": `style_interface_foot__oHGfh`,
	"container": `style_container__p893W`,
	"flicker": `style_flicker__JRMWg`,
	"overlay": `style_overlay__1QE8+`,
	"distort": `style_distort__FaXdh`,
	"vignette": `style_vignette__-1jNA`,
	"glitch-block": `style_glitch-block__AwTIC`,
	"glitch-anim-1": `style_glitch-anim-1__dh-nH`,
	"glitch-anim-2": `style_glitch-anim-2__PuM0I`,
	"text-glitch": `style_text-glitch__wKIaX`,
	"noise-anim": `style_noise-anim__snOkt`
};
export default ___CSS_LOADER_EXPORT___;
